import { MenuItem } from '@affine/component';
import { UserFeatureService } from '@affine/core/modules/cloud';
import { WorkspaceDialogService } from '@affine/core/modules/dialogs';
import { useI18n } from '@affine/i18n';
import { track } from '@affine/track';
// import { AccountIcon, AdminIcon, SignOutIcon } from '@blocksuite/icons/rc';
import { useService } from '@toeverything/infra';
import IconFont from '@ys/repo-ui/base/IconFont';
import { useCallback, useEffect } from 'react';

import { useSignOut } from '../../hooks/affine/use-sign-out';
import * as styles from './index.css';

export const AccountMenu = () => {
  const workspaceDialogService = useService(WorkspaceDialogService);
  const openSignOutModal = useSignOut();
  // const serverService = useService(ServerService);
  const userFeatureService = useService(UserFeatureService);
  // const isAFFiNEAdmin = useLiveData(userFeatureService.userFeature.isAdmin$);

  const onOpenAccountSetting = useCallback(() => {
    track.$.navigationPanel.profileAndBadge.openSettings({ to: 'account' });
    workspaceDialogService.open('setting', {
      activeTab: 'account',
    });
  }, [workspaceDialogService]);

  // const onOpenAdminPanel = useCallback(() => {
  //   window.open(`${serverService.server.baseUrl}/admin`, '_blank');
  // }, [serverService.server.baseUrl]);

  const t = useI18n();

  useEffect(() => {
    userFeatureService.userFeature.revalidate();
  }, [userFeatureService]);

  return (
    <>
      <MenuItem
        prefixIcon={
          <IconFont name="settings" className={styles.accountMenuItemIcon} />
        }
        data-testid="workspace-modal-account-settings-option"
        onClick={onOpenAccountSetting}
      >
        {t['com.affine.workspace.cloud.account.settings']()}
      </MenuItem>
      {/* <MenuItem
        prefixIcon={
          <IconFont name="community" className={styles.accountMenuItemIcon} />
        }
        data-testid="workspace-modal-account-settings-option"
        onClick={onOpenAccountSetting}
      >
        {t['com.affine.workspace.cloud.account.community']()}
      </MenuItem> */}
      {/* {isAFFiNEAdmin ? (
        <MenuItem
          prefixIcon={<AdminIcon />}
          data-testid="workspace-modal-account-admin-option"
          onClick={onOpenAdminPanel}
        >
          {t['com.affine.workspace.cloud.account.admin']()}
        </MenuItem>
      ) : null} */}
      <MenuItem
        prefixIcon={
          <IconFont name="signout" className={styles.accountMenuItemIcon} />
        }
        data-testid="workspace-modal-sign-out-option"
        onClick={openSignOutModal}
      >
        {t['com.affine.workspace.cloud.account.logout']()}
      </MenuItem>
    </>
  );
};
